import { render, staticRenderFns } from "./OpenShiftsDashboard.vue?vue&type=template&id=2e29e344&"
import script from "./OpenShiftsDashboard.vue?vue&type=script&lang=js&"
export * from "./OpenShiftsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OpenShiftsDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCard,VCol,VContainer,VProgressLinear,VRow,VSimpleTable,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e29e344')) {
      api.createRecord('2e29e344', component.options)
    } else {
      api.reload('2e29e344', component.options)
    }
    module.hot.accept("./OpenShiftsDashboard.vue?vue&type=template&id=2e29e344&", function () {
      api.rerender('2e29e344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduling/reports/OpenShiftsDashboard.vue"
export default component.exports